import { signal } from '@angular/core';
import * as i0 from "@angular/core";
export class PasskeyLoginErrorService {
    constructor() {
        this.errorMessage = signal(null, ...(ngDevMode ? [{ debugName: "errorMessage" }] : []));
    }
    setError(message) {
        this.errorMessage.set(message);
    }
    clear() {
        this.errorMessage.set(null);
    }
}
PasskeyLoginErrorService.ɵfac = function PasskeyLoginErrorService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasskeyLoginErrorService)(); };
PasskeyLoginErrorService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PasskeyLoginErrorService, factory: PasskeyLoginErrorService.ɵfac, providedIn: 'root' });
